


















































































































































import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { IdentityFullInfo } from '../types';
import { StateEnum, useStore } from '@tt4b/ttam-hooks';
import { AvatarIcon, BC_IDENTITY_TYPES_LIST, IDENTITY_TYPE_MAP, IDENTITY_ACCOUNT_TYPE } from '@tt4b/ttam-enums';
import { trackEvent } from './../../../utils/index';
import { IdentityInfo } from '@tt4b/ttam-enums/src/types';
import { getImgSrcByEnv, imgSrcPrefix } from '@tt4b/ttam-utils';
import { i18n } from './../../../i18n';

const defaultAvatar =
  'https://sf16-sg.tiktokcdn.com/obj/eden-sg/lm_zkh_rvarpa/ljhwZthlaukjlkulzlp/ads_manager_creation/default-avatar.png';
const name = 'ttam-identity-tiktok-list-item';

export default defineComponent({
  name,
  props: {
    isSupportBCNvN: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Object as PropType<IdentityFullInfo>,
      default: () => ({}),
    },
    onClick: {
      type: Function as PropType<(i: IdentityFullInfo) => void>,
      default: () => () => undefined,
    },
    onDeleteIdentity: {
      type: Function as PropType<(i: IdentityFullInfo) => void>,
      default: () => () => undefined,
    },
    onEditIdentity: {
      type: Function as PropType<(i: IdentityFullInfo) => void>,
      default: () => () => undefined,
    },
    onAuthorizeBA: {
      type: Function as PropType<() => void>,
      default: () => () => undefined,
    },
    onPopoverCTA: {
      type: Function as PropType<(i: IdentityFullInfo) => void>,
      default: () => () => undefined,
    },
    activeData: {
      type: Object as PropType<IdentityInfo>,
      default: () => ({
        displayName: '',
        avatarIcon: {
          width: 20,
          height: 20,
          webUri: '',
          url: '',
        },
        identityId: '',
        identityBcId: '',
        identityType: 3,
      }),
    },
    isSupportEditAndDelete: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { state } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);

    const { source, activeData } = toRefs(props);

    const useIdentityAvatarUrl = (avatar: AvatarIcon): string => {
      if (avatar?.url) {
        return avatar.url;
      }
      if (avatar?.webUri) {
        return getImgSrcByEnv({ URL: imgSrcPrefix.URL }, avatar.webUri);
      }
      return defaultAvatar;
    };

    const sourceAvatar = computed(() => useIdentityAvatarUrl(props.source?.avatarIcon as AvatarIcon));

    const isActive = computed(() => {
      if (BC_IDENTITY_TYPES_LIST.includes(activeData.value?.identityType)) {
        return (
          source.value?.identityId === activeData.value?.identityId &&
          source.value?.identityBcId === activeData.value?.identityBcId
        );
      }

      return source.value?.identityId === activeData.value?.identityId;
    });

    const onClickItem = () => {
      if (!source.value.bannerType && !props.source.disabled && !isActive.value) {
        props.onClick(props.source);
      }
    };

    const authorizeBA = () => {
      trackEvent('creative_identity_bind_ttba_start');
      props.onAuthorizeBA();
    };

    const authorizeBC = () => {
      trackEvent('creative_identity_bind_ttbc_start');
      window.open(`https://business.tiktok.com/select?ttam_id=${aadvid.value}&action=tiktok&request_role=1`, '_blank');
    };

    const onPopoverCTAItem = () => {
      props.onPopoverCTA(props.source);
    };
    const handleEditIdentity = () => {
      props.onEditIdentity(props.source);
      trackEvent('edit_custom_identity');
    };
    const handleDeleteIdentity = () => {
      props.onDeleteIdentity(props.source);
      trackEvent('delete_custom_identity');
    };

    /** whitelist: ttbc - NvN */
    const description = computed(() =>
      [
        source.value.username,
        source.value.accountType === IDENTITY_ACCOUNT_TYPE.BA && i18n.t('creative_auth_identity_desc'),
      ]
        .filter(Boolean)
        .join(' | '),
    );

    return {
      name,
      aadvid,
      isActive,
      sourceAvatar,
      IDENTITY_TYPE_MAP,
      description,

      authorizeBA,
      authorizeBC,
      onClickItem,
      onPopoverCTAItem,
      handleEditIdentity,
      handleDeleteIdentity,
    };
  },
});
